import { Cloud, CloudDrizzle, CloudRain, CloudSnow, CloudSun, Sun } from 'lucide-react';

interface PropsWeatherGlyph {
  slug: string | null;
  size?: number;
  color?: string;
}

export default function WeatherGlyph({ slug, size = 28, color = '#1F6D89' }: PropsWeatherGlyph) {
  const lc = (slug ?? '').toLowerCase();
  if (lc.includes('snow')) return <CloudSnow size={size} color={color} />;
  if (lc.includes('rain') || lc.includes('chuva')) return <CloudRain size={size} color={color} />;
  if (lc.includes('drizzle')) return <CloudDrizzle size={size} color={color} />;
  if (lc.includes('cloud') || lc.includes('nublado')) return <Cloud size={size} color={color} />;
  if (lc.includes('partly')) return <CloudSun size={size} color={color} />;
  return <Sun size={size} color="#FFBB33" />;
}
